export default __webpack_public_path__ + "static/media/raindrop.0b19ef2b.png";